import { Component, ElementRef, Renderer2, AfterViewInit } from '@angular/core';
import { Router } from '@angular/router';

@Component({
  selector: 'shared-sidebar',
  standalone: false,
  templateUrl: './sidebar.component.html',
  styleUrl: './sidebar.component.scss'
})
export class SidebarComponent implements AfterViewInit {

  constructor(private el: ElementRef, private renderer: Renderer2) { }

  ngAfterViewInit() {
    this.setupSidebarToggle();
    this.setupDropdownToggle();
    this.setupNavLinkClick();
  }

  // Toggle 'is-active' class in sidebar
  setupSidebarToggle() {
    const sidebarLink = this.el.nativeElement.querySelectorAll('.sidebar__link');
    const sidebar = this.el.nativeElement.querySelector('.sidebar');

    sidebarLink.forEach((link: HTMLElement) => {
      this.renderer.listen(link, 'click', () => {
        if (sidebar.classList.contains('is-active')) {
          this.renderer.removeClass(sidebar, 'is-active');
          this.closeAllSubmenus();
        } else {
          this.renderer.addClass(sidebar, 'is-active');
        }
      });
    });
  }

  // Configure dropdown functionality in the sidebar
  setupDropdownToggle() {
    const dropdowns = this.el.nativeElement.querySelectorAll('.nav__dropdown');

    dropdowns.forEach((dropdown: HTMLElement) => {
      this.renderer.listen(dropdown, 'click', (event) => {
        event.preventDefault();
        const parentItem = dropdown.closest('.nav__item') as HTMLElement | null;
        const subnav = parentItem?.querySelector('.subnav') as HTMLElement | null;

        // Verify that parentItem and subnav are valid before running the functions
        if (parentItem && subnav) {
          if (parentItem.classList.contains('is-active')) {
            this.closeSubmenu(subnav, parentItem);
          } else {
            this.closeAllSubmenus();
            this.openSubmenu(subnav, parentItem);
          }
        }
      });
    });
  }

  // Handle clicks on navigation links
  setupNavLinkClick() {
    const navLinks = this.el.nativeElement.querySelectorAll('.nav__link');
    const sidebar = this.el.nativeElement.querySelector('.sidebar');

    navLinks.forEach((link: HTMLElement) => {
      this.renderer.listen(link, 'click', () => {
        // We do not close the sidebar if it is already open, we only ensure its opening
        if (!sidebar.classList.contains('is-active')) {
          this.renderer.addClass(sidebar, 'is-active');
        }
      });
    });
  }

  // Close all submenus
  private closeAllSubmenus() {
    const subnavs = this.el.nativeElement.querySelectorAll('.subnav');
    const navItems = this.el.nativeElement.querySelectorAll('.nav__item');

    subnavs.forEach((subnav: HTMLElement) => {
      this.renderer.setStyle(subnav, 'display', 'none');
    });

    navItems.forEach((item: HTMLElement) => {
      this.renderer.removeClass(item, 'is-active');
    });
  }

  // Close a specific submenu
  private closeSubmenu(subnav: HTMLElement, parentItem: HTMLElement) {
    this.renderer.setStyle(subnav, 'display', 'none');
    this.renderer.removeClass(parentItem, 'is-active');
  }

  // Open a specific submenu
  private openSubmenu(subnav: HTMLElement, parentItem: HTMLElement) {
    this.renderer.setStyle(subnav, 'display', 'block');
    this.renderer.addClass(parentItem, 'is-active');
  }
}

